import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = { class: "register-form-wrapper" }
const _hoisted_3 = { class: "header-area" }
const _hoisted_4 = { class: "login-link" }

import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { User, Lock, Message, Phone, ArrowLeft } from '@element-plus/icons-vue';
import { register } from '@/user/api/auth';

interface RegisterForm {
  username: string;
  password: string;
  confirmPassword: string;
  email?: string;
  phone?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

const router = useRouter();
const registerFormRef = ref();
const loading = ref(false);

const registerForm = reactive<RegisterForm>({
  username: '',
  password: '',
  confirmPassword: '',
  email: '',
  phone: ''
});

const validateConfirmPassword = (rule: any, value: string, callback: any) => {
  if (value === '') {
    callback(new Error('请再次输入密码'));
  } else if (value !== registerForm.password) {
    callback(new Error('两次输入的密码不一致'));
  } else {
    callback();
  }
};

const validateEmail = (rule: any, value: string, callback: any) => {
  if (value === '') {
    callback();
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      callback(new Error('请输入正确的邮箱格式'));
    } else {
      callback();
    }
  }
};

const validatePhone = (rule: any, value: string, callback: any) => {
  if (value === '') {
    callback();
  } else {
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(value)) {
      callback(new Error('请输入正确的手机号码'));
    } else {
      callback();
    }
  }
};

const rules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 3, max: 20, message: '用户名长度在3-20个字符之间', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度在6-20个字符之间', trigger: 'blur' }
  ],
  confirmPassword: [
    { validator: validateConfirmPassword, trigger: 'blur' }
  ],
  email: [
    { validator: validateEmail, trigger: 'blur' }
  ],
  phone: [
    { validator: validatePhone, trigger: 'blur' }
  ]
};

const handleRegister = async () => {
  // 验证表单
  try {
    await registerFormRef.value.validate();
  } catch {
    ElMessage.error('请检查输入信息');
    return;
  }

  // 开始注册
  loading.value = true;
  try {
    const { confirmPassword, ...params } = registerForm;
    const response = await register(params);
    
    if (response.code === 1) {
      ElMessage.success('注册成功！');
      // 注册成功后跳转到登录页
      setTimeout(() => {
        router.push('/login');
      }, 1000);
    } else {
      ElMessage.error(response.msg || '注册失败');
    }
  } catch (error: any) {
    console.error('注册失败:', error);
    ElMessage.error(error.message || '注册失败，请稍后重试');
  } finally {
    loading.value = false;
  }
};

const goToLogin = () => {
  router.push('/login');
};

const goBack = () => {
  // 尝试返回上一页，如果不存在则跳转到首页
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    router.push('/');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "yarn-ball-decoration" }, null, -1)),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "yarn-ball-decoration secondary" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          icon: _unref(ArrowLeft),
          type: "default",
          onClick: goBack,
          plain: "",
          circle: "",
          class: "back-button"
        }, null, 8, ["icon"]),
        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "form-title" }, "🧵 注册新账号", -1))
      ]),
      _createVNode(_component_el_form, {
        model: registerForm,
        rules: rules,
        ref_key: "registerFormRef",
        ref: registerFormRef,
        "label-width": "80px",
        class: "register-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "用户名",
            prop: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registerForm.username) = $event)),
                "prefix-icon": _unref(User),
                placeholder: "请输入用户名",
                size: "large"
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "密码",
            prop: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registerForm.password) = $event)),
                type: "password",
                "prefix-icon": _unref(Lock),
                placeholder: "请输入密码",
                size: "large",
                "show-password": ""
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "确认密码",
            prop: "confirmPassword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.confirmPassword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registerForm.confirmPassword) = $event)),
                type: "password",
                "prefix-icon": _unref(Lock),
                placeholder: "请再次输入密码",
                size: "large",
                "show-password": ""
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "邮箱",
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registerForm.email) = $event)),
                "prefix-icon": _unref(Message),
                placeholder: "请输入邮箱地址（可选）",
                size: "large"
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((registerForm.phone) = $event)),
                "prefix-icon": _unref(Phone),
                placeholder: "请输入手机号码（可选）",
                size: "large"
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleRegister,
                loading: loading.value,
                class: "register-button",
                size: "large"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" 注册 ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createTextVNode(" 已有账号？ ", -1)),
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: goToLogin
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("立即登录", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})